import { Component, Watch } from 'vue-property-decorator'

import { Item, Location as LocationEntity } from '@skinsoft/types'
import { itemSelectors, locationSelectors } from '@skinsoft/selectors'
import { LocationDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'

@Component({
    props: ['item', 'displayPath', 'dataCy'],
    template: require('./location.html'),
})
export class Location extends ReactiveVue {
    public item: Item;
    public displayPath: boolean;

    public $locationDataStore: LocationDataStore;
    public locationSelectors = locationSelectors;
    public location: LocationEntity = null as any;
    private fullPathLocation: string = "";
    private firstSynonym: string = "";
    private isPermanent: boolean = false;

    public created() {
        this.subscribe();
    }

    private subscribe() {
        let locationId = itemSelectors.realTimeLocation(this.item);

        // Taking permanent location if no real-time one is available
        if (!locationId) {
            locationId = itemSelectors.permanentLocation(this.item);
            this.isPermanent = true;
        }

        if (!locationId) {
            this.$emit('ready');
            return;
        }

        this.subscribeTo(
            this.$locationDataStore.fetchOne(locationId),
            async location => {
                this.$emit('ready');
                this.location = location;
                this.fullPathLocation = await this.$locationDataStore.resolvePath(locationSelectors.pathIds(location), this.$i18n.locale)
                this.firstSynonym = locationSelectors.firstSynonym(location, this.$i18n.locale)
            },
            'location',
        );
    }

    @Watch('item')
    private onItemChange() {
        this.isPermanent = false;
        this.unsubscribeFrom('location');
        this.subscribe();
    }
}
